import { DEFAULT_LOCALE, isLocale, type Locale } from '@pickpro/i18n';

function matchLanguage(language: string): Locale | null {
  const lower = language.toLowerCase();
  if (lower === 'pt' || lower.startsWith('pt-')) return 'pt-BR';
  if (lower === 'en' || lower.startsWith('en-')) return 'en';
  if (lower === 'es' || lower.startsWith('es-')) return 'es';
  return null;
}

export function resolveLocale(input: {
  saved: string | null;
  browserLanguages: readonly string[];
}): Locale {
  if (isLocale(input.saved)) return input.saved;
  for (const language of input.browserLanguages) {
    const match = matchLanguage(language);
    if (match) return match;
  }
  return DEFAULT_LOCALE;
}
